import { useSelector } from 'react-redux';

// Fallback used when the settings store has not been loaded yet
// (matches the historical hard-coded defaults across the app).
export const FALLBACK_DEFAULT_MARGIN = 33;
export const FALLBACK_DEFAULT_MARKUP = 49.25;

// Given a margin percentage, derive the equivalent markup percentage
// so that: clientPrice = builderCost * (1 + markup/100) yields the desired margin.
//   margin = (clientPrice - builderCost) / clientPrice
//   markup = margin / (1 - margin)
export const marginToMarkup = (marginPct) => {
  const m = Number(marginPct);
  if (!Number.isFinite(m) || m <= 0) return 0;
  if (m >= 100) return 0;
  const markup = (m / (100 - m)) * 100;
  return Math.round((markup + Number.EPSILON) * 100) / 100;
};

// Read the resolved defaults from the settings store (with safe fallbacks).
export const selectPricingDefaults = (state) => {
  const stored = state?.settings?.appSettings?.pricingDefaults?.defaultMargin;
  const defaultMargin = Number.isFinite(Number(stored))
    ? Number(stored)
    : FALLBACK_DEFAULT_MARGIN;
  const defaultMarkup = marginToMarkup(defaultMargin);
  return {
    defaultMargin,
    defaultMarkup: defaultMarkup || FALLBACK_DEFAULT_MARKUP
  };
};

// Convenience hook for components.
export const usePricingDefaults = () => useSelector(selectPricingDefaults);
